const pathReducer = (state = ['Home'], action) => {
  switch (action.type) {
    case 'APPEND_PATH':
      return [...state, action.payload];
    case 'SET_PATH':
      return [action.payload];
    default:
      return state;
  }
};

export default pathReducer;
